import { keyExists } from "./highliter";

const iterate = (search, node, collections) => {
  if (node.hasChildren) {
    for (const key in node.children) {
      const result = iterate(search, node.children[key], collections);

      if (result !== undefined) {
        collections.push(node.code);
      }
      if (collections.includes(node.code) && node?.parentid) {
        collections.push(node.parentid);
      }
    }
  }

  if (node.code && node.description) {
    if (
      keyExists(search, node.code) !== false ||
      keyExists(search, node.description) !== false ||
      keyExists(search, node.synonyme) !== false ||
      keyExists(search, node.keywords) !== false
    ) {
      return node.code;
    }
  }
};

const nodeFinder = (key, node) => {
  const collections = [];
  iterate(key, node, collections);
  return [...new Set(collections)];
};

export default nodeFinder;
